import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
} from '@angular/core';
import { GlobalServices } from '../global.services';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
} from '@angular/forms';
import { ApiService } from '../api.service';
import { UserContactService } from '../services/user-contact.service';
import { baseUrls } from '../appConstant';
import { SubscriptionPlanService } from '../services/subscription-plan.service';
import { Subscription } from 'rxjs';
import { ProductService } from '../services/product.service';
import { ActivatedRoute,Router } from '@angular/router';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  public showAlert: boolean = false;
  public responseMessage: string = '';
  public submitted: boolean = false;
  slideConfig = {}; //slick config
  baseUrls = baseUrls;
  @ViewChild('slickModal') slickModal: SlickCarouselComponent;
  emailForm: FormGroup;
  showButtonForPlanPageRoute;
  subscriptionForMoveToPlan = new Subscription();
  constructor(
    public globalService: GlobalServices,
    public fb: FormBuilder,
    public viewContainerRef: ViewContainerRef,
    public cfr: ComponentFactoryResolver,
    public httpService: ApiService,
    private subscriptionPlanService: SubscriptionPlanService,
    private productService: ProductService,
    private route: ActivatedRoute,
    private router:Router
  ) {
    this.emailForm = this.fb.group({
      email: [null, [Validators.required, checkValidatePssword.bind(this)]],
    });
    function checkValidatePssword(controls: AbstractControl): {
      passwordCheck: boolean;
    } {
      let password = controls.value;
      if (password) {
        if (
          password.indexOf('@') > -1 &&
          password.indexOf('.') > -1 &&
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
            password
          )
        ) {
          return null;
        } else {
          return { passwordCheck: true };
        }
      }
      return null;
    }
  }
  get f() {
    return this.emailForm.controls;
  }
  ngOnInit(): void {
    if (this.globalService.isBrowser) {
      this.globalService?.hideHeader.next(false);
      this.globalService?.hideFooter.next(false);
      this.slickSlider();
      this.globalService.headerviewcontainerhelper = this.viewContainerRef;
      this.globalService.headercrf = this.cfr;
      // this.responseMessage = 'Please submit atleast one Traveller data for each of the Travel Programs and/or check email addresses entered!';
      // this.showAlert = true;
      this.getSubscriptionPlan();
      this.showButtonForPlanPageRoute =
        localStorage.getItem('moveToPlanPage') == 'false' ? false : true;
      this.subscriptionForMoveToPlan =
        this.globalService?.moveToPlanPage.subscribe((isChanged: any) => {
          if (isChanged == false) {
            this.showButtonForPlanPageRoute = false;
          }
        });
      this.getShopProducts();
      this.packagesData();
    }
    const token: string = this.route.snapshot.queryParamMap.get('token');
    const userDetails: string = this.route.snapshot.queryParamMap.get('userDetails');
    if (token) {
      localStorage.setItem('userDetails', userDetails);
      localStorage.setItem('userToken', token);      
      window.location.href = '/';
    }

  }
  opensignupmodal() {
    this.globalService.viewcontainerhelper = this.viewContainerRef;
    this.globalService.triggersignup(this.viewContainerRef, this.cfr);
  }
  slideConfigForBanner = {};
  slideConfigForPopularClasses = {};
  slideConfigForTravel = {};
  slideConfigForShop = {};
  slideConfigForBlog = {};
  slideConfigForMainBanner = {};
  slickSlider() {
    this.slideConfig = {
      slidesToShow: 3,
      slidesToScroll: 1,
      nextArrow: "<div class='nav-btn next-slide next-testimonials'></div>",
      prevArrow: "<div class='nav-btn prev-slide prev-testimonials '></div>",
      infinite: true,
      centerPadding: '2px',
      centerMode: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            infinite: true,
            centerPadding: '2px',
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '180px',
            infinite: true,
          },
        },
        {
          breakpoint: 676,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '100px',
            infinite: true,
          },
        },
        {
          breakpoint: 376,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '70px',
            infinite: true,
          },
        },
      ],
    };
    this.slideConfigForBanner = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: true,
      dots: true,
    };
    this.slideConfigForPopularClasses = {
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      responsive: [
        {
          breakpoint: 1799,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 1499,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            infinite: true,
            centerPadding: '2px',
            arrows: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '15px',
            infinite: true,
            arrows: false,
            dots: true,
          },
        },
        {
          breakpoint: 676,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '15px',
            infinite: true,
            arrows: false,
            dots: true,
          },
        },
        {
          breakpoint: 376,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '0',
            infinite: true,
            arrows: false,
            dots: true,
          },
        },
      ],
    };
    this.slideConfigForTravel = {
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1799,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            infinite: true,
            centerPadding: '2px',
            arrows: false,
            dots: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            centerPadding: '0',
            infinite: true,
            arrows: false,
            dots: true,
          },
        },
      ],
    };
    this.slideConfigForShop = {
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1799,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            infinite: true,
            centerPadding: '2px',
            arrows: false,
            dots: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: true,
          },
        },
      ],
    };
    this.slideConfigForBlog = {
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1799,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            infinite: true,
            centerPadding: '2px',
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '180px',
            infinite: true,
            arrows: false,
          },
        },
        {
          breakpoint: 676,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '100px',
            infinite: true,
            arrows: false,
          },
        },
        {
          breakpoint: 376,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '50px',
            infinite: true,
            arrows: false,
          },
        },
      ],
    };

    this.slideConfigForMainBanner = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: true,
      dots: true,
      // responsive: [
      //   {
      //     breakpoint: 1799,
      //     settings: {
      //       slidesToShow: 1,
      //       slidesToScroll: 1,
      //       arrows: false,
      //     },
      //   },
      //   {
      //     breakpoint: 991,
      //     settings: {
      //       slidesToShow: 1,
      //       slidesToScroll: 1,
      //       centerMode: true,
      //       infinite: true,
      //       arrows: false,
      //       centerPadding: '2px',
      //     },
      //   },
      //   {
      //     breakpoint: 767,
      //     settings: {
      //       slidesToShow: 1,
      //       slidesToScroll: 1,
      //       centerMode: true,
      //       centerPadding: '180px',
      //       infinite: true,
      //       arrows: false,
      //     },
      //   },
      //   {
      //     breakpoint: 676,
      //     settings: {
      //       slidesToShow: 1,
      //       slidesToScroll: 1,
      //       centerMode: true,
      //       centerPadding: '100px',
      //       infinite: true,
      //       arrows: false,
      //     },
      //   },
      //   {
      //     breakpoint: 376,
      //     settings: {
      //       slidesToShow: 1,
      //       slidesToScroll: 1,
      //       centerMode: true,
      //       centerPadding: '50px',
      //       infinite: true,
      //       arrows: false,
      //     },
      //   },
      // ],
    };
  }

  submit() {
    this.submitted = true;
    if (this.emailForm.valid) {
      let urlSubscribe = 'global/newsletter';
      let data = { email: this.emailForm.value.email };
      this.httpService.postFormData(urlSubscribe, data).subscribe((res) => {
        this.showAlert = true;
        this.responseMessage = res.message;
        if (this.globalService.isBrowser) {
          setTimeout(() => {
            this.submitted = false;
          }, 2000);
        }
      });
    } else {
      return;
    }
  }
  public triggerCloseEvent() {
    this.showAlert = false;
  }

  bannerData = [
    {
      imgSrc: '../../assets/images/imgpsh_fullsize_anim.jpeg',
      goToUrl: 'https://www.instagram.com/p/CN1-nxwgww9/',
    },
    {
      imgSrc: '../../assets/images/imgpsh_fullsize_anim.jpeg',
      goToUrl: 'https://www.instagram.com/p/CNz8Kk8r0sy/',
    },
    {
      imgSrc: '../../assets/images/imgpsh_fullsize_anim.jpeg',
      goToUrl: 'https://www.instagram.com/p/COfLXoyAXD0/',
    },
    {
      imgSrc: '../../assets/images/imgpsh_fullsize_anim.jpeg',
      goToUrl: 'https://www.instagram.com/p/CO2dU3LrckQ/',
    },
    {
      imgSrc: '../../assets/images/imgpsh_fullsize_anim.jpeg',
      goToUrl: 'https://www.instagram.com/p/CNcvPF6gfdg/',
    },
    {
      imgSrc: '../../assets/images/imgpsh_fullsize_anim.jpeg',
      goToUrl: 'https://www.instagram.com/p/CM0IRQdAu6_/',
    },
    {
      imgSrc: '../../assets/images/imgpsh_fullsize_anim.jpeg',
      goToUrl: 'https://www.instagram.com/p/CM5WVLsl_KD/',
    },
    {
      imgSrc: '../../assets/images/imgpsh_fullsize_anim.jpeg',
      goToUrl: 'https://www.instagram.com/p/CMuViIAgB0Y/',
    },
  ];

  instaData = [
    {
      imgSrc: 'assets/images/insta/insta1.jpg',
      goToUrl: 'https://www.instagram.com/p/CN1-nxwgww9/',
    },
    {
      imgSrc: 'assets/images/insta/insta2.jpg',
      goToUrl: 'https://www.instagram.com/p/CNz8Kk8r0sy/',
    },
    {
      imgSrc: 'assets/images/insta/insta3.jpg',
      goToUrl: 'https://www.instagram.com/p/COfLXoyAXD0/',
    },
    {
      imgSrc: 'assets/images/insta/insta4.jpg',
      goToUrl: 'https://www.instagram.com/p/CO2dU3LrckQ/',
    },
    {
      imgSrc: 'assets/images/insta/insta5.jpg',
      goToUrl: 'https://www.instagram.com/p/CNcvPF6gfdg/',
    },
    {
      imgSrc: 'assets/images/insta/insta6.jpg',
      goToUrl: 'https://www.instagram.com/p/CM0IRQdAu6_/',
    },
    {
      imgSrc: 'assets/images/insta/insta7.jpg',
      goToUrl: 'https://www.instagram.com/p/CM5WVLsl_KD/',
    },
    {
      imgSrc: 'assets/images/insta/insta8.jpg',
      goToUrl: 'https://www.instagram.com/p/CMuViIAgB0Y/',
    },
  ];
  instagramClick(urlLink) {
    if (this.globalService?.isBrowser && urlLink) {
      window.open(urlLink);
    }
  }
  goToUrl(urlLink) {
    if (this.globalService?.isBrowser && urlLink) {
      window.open(urlLink);
    }
  }
  goToSection(sectionLink) {
    this.goToUrl(this.baseUrls?.hostedUrl + sectionLink);
  }

  goToLink(url){
    window.open(url, "_blank");
  }

  ratingForTravel = 5;
  subscriptionPlan;
  getSubscriptionPlan() {
    this.subscriptionPlanService
      .getSubscriptionDetail()
      .subscribe((response: any) => {
        if (response) {
          this.subscriptionPlan = response?.data;
        }
      });
  }
  goToSubscriptionPage() {
    if (this.globalService.isBrowser) {
      // debugger
      // if(this.globalService?.isLoggedIn){
      //   let userSubscriptionPlan = JSON.parse(localStorage.getItem('userSubscriptionPlan'));
      //   let flagForSubscriptionFoundInUserPlan = false;
      //   userSubscriptionPlan.forEach((obj: any) => {
      //     console.log('goToSubscriptionPage_2', obj?._id == this.subscriptionPlan?._id, obj?._id, this.subscriptionPlan?._id);
      //     if(obj?._id == this.subscriptionPlan?._id){
      //       flagForSubscriptionFoundInUserPlan = true;
      //     }
      //   })
      //   if(flagForSubscriptionFoundInUserPlan){
      //     this.showAlert = true;
      //     this.responseMessage = "Already Subscribed For Plan."
      //   }
      //   else{
      //   window.location.href = this.baseUrls?.hostedUrl+'register/' + this.subscriptionPlan?._id+'-monthly'
      //   }
      // }
      // else{
      window.location.href =
        this.baseUrls?.hostedUrl +
        'register/' +
        this.subscriptionPlan?._id +
        '-monthly';
      // }
    }
  }
  shopProductData;
  popularClassData;
  travelData;
  packagesData() {
    this.popularClassData = [
      {
        gotoUrl:
          'https://www.mylifewell.com/livewell/class/vinyasa-full-body-yoga-flow',
        thumbUrl:
          'https://assets-jpcust.jwpsrv.com/thumbnails/ilm5gt62-720.jpg',
        title: 'Vinyasa: Uplifting Yoga Flow',
      },
      {
        gotoUrl:
          'https://www.mylifewell.com/livewell/class/vineyard-bootcamp-1',
        thumbUrl:
          'https://cdn.jwplayer.com/v2/media/sl3TPbMt/poster.jpg?width=720',
        title: 'Vineyard Bootcamp 1',
      },
      {
        gotoUrl:
          'https://www.mylifewell.com/livewell/class/gratitude-meditation',
        thumbUrl: 'https://cdn.jwplayer.com/v2/media/J7NlwITB/poster.jpg',
        title: 'Gratitude Meditation',
      },
      {
        gotoUrl: 'https://www.mylifewell.com/livewell/class/vineyard-cycle-3',
        thumbUrl: 'https://cdn.jwplayer.com/v2/media/6l9Is9Zq/poster.jpg',
        title: 'Vineyard Cycle 3',
      },
    ];
    this.travelData = [
      {
        gotoUrl:
          'https://www.mylifewell.com/travel/destinations/the-americas/costa-rica/Tours/costa-rica-kayaking-adventure',
        imgUrl:
          'https://cdn.mylifewell.com/uploads/2020/10/350x250/5f7de532e85f043c02473817.jpg',
        type: 'Tour',
        programName: 'Costa Rica Kayaking Adventure',
        programBy: 'San José',
        price: '1019.00',
        pType: 'pp',
      },
      {
        gotoUrl:
          'https://www.mylifewell.com/travel/destinations/asia/indonesia/tours/wellness-bali',
        imgUrl:
          'https://cdn.mylifewell.com/uploads/2020/10/350x250/5f7de534e85f043c02473821.jpg',
        type: 'Tour',
        programName: 'Wellness Bali',
        programBy: ' Ubud , Sanur ',
        price: '1317.00',
        pType: 'pp',
      },
      {
        gotoUrl:
          'https://www.mylifewell.com/travel/destinations/the-americas/mexico/hotels-resorts/holistic-wellness-retreat',
        imgUrl:
          'https://cdn.mylifewell.com/uploads/2020/10/350x250/167d6672-c2da-41a0-af3b-ec708e287aa6.jpg',
        type: 'Hotels & Resorts',
        programName: 'Holistic Wellness Retreat',
        programBy: 'Playa del Carmen, Quintana Roo, Mexico',
        price: '315.00',
        pType: 'pp/night',
      },
      {
        gotoUrl:
          'https://www.mylifewell.com/travel/destinations/western-europe/italy/Tours/cycling-in-tuscany',
        imgUrl:
          'https://cdn.mylifewell.com/uploads/2020/10/350x250/5f7de538e85f043c02473837.jpg',
        type: 'Tour',
        programName: 'Cycling in Tuscany',
        programBy: 'Roma, Italy',
        price: '1395.00',
        pType: 'pp',
      },
      {
        gotoUrl:
          'https://www.mylifewell.com/travel/destinations/western-europe/iceland/tours/wellness-iceland-the-ultimate-hiking-and-meditation-experience',
        imgUrl:
          'https://cdn.mylifewell.com/uploads/2020/10/350x250/5f7de529e85f043c024737e0.jpg',
        type: 'Tour',
        programName: 'Wellness Iceland - The Ultimate',
        programBy: 'Reykjavík, Höfuðborgarsvæði, Iceland',
        price: '2549.00',
        pType: 'pp',
      },
    ];
  }
  getShopProducts() {
    let obj = {
      start: 0,
      length: 6,
      col: 'saleCount',
      dir_status: '-1',
      search: {
        category: ['60535110f8c41047f1725b7e'],
        subcategory: [],
        tags: [],
        price: [],
        brand: [],
        colors: [],
        sizes: [],
      },
    };
    this.productService?.postProducts(obj).subscribe((response: any) => {
      if (response) {
        this.shopProductData = response;
      }
    });
  }
  ngOnDestroy() {
    this.subscriptionForMoveToPlan.unsubscribe();
  }
}
